import React from 'react';
import '../styles/ProjectsPage.scss';
import Sidebar from './Sidebar';
import Portfolio from './Portfolio';

const ProjectsPage = props => (
  <main className="ProjectsPage">
    <Sidebar {...props} />
    <Portfolio {...props} />
  </main>
);

export default ProjectsPage;



// WEBPACK FOOTER //
// ./src/components/ProjectsPage.js